import { effect as l, setAttribute as s, template as c } from "solid-js/web";
var i = c('<svg xmlns=http://www.w3.org/2000/svg width=24 height=24 viewBox="0 0 256 256"data-scope=button data-part=icon><path d=M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z>');
const v = (e) => {
  return a = i(), l((t) => {
    var o = e.color || "currentColor", r = e.class;
    return o !== t.e && s(a, "fill", t.e = o), r !== t.t && s(a, "class", t.t = r), t;
  }, { e: void 0, t: void 0 }), a;
  var a;
};
export {
  v as NextIcon
};
